import { useState, React } from 'react';

import Plan11 from './1.1';
import Plan12 from './1.2';
import Plan13 from './1.3';
import Plan21 from './2.1';
import Plan22 from './2.2';
import Plan23 from './2.3';
import Plan24 from './2.4';
import Plan25 from './2.5';
import Plan31 from './3.1';
import Plan32 from './3.2';

import { RemainingTimeContext } from '../../../../context/TimerContext';

import {
  convertToRequestData,
  convertToTableData
} from './1.2/utilities/convertData';

const Plan = ({ menu, childToParent }) => {
  const { selectedApas, apa_form, form_no } = menu;
  console.log("menu", menu, "selectedApas", selectedApas, "apa_form", apa_form, "form_no", form_no);

  if (form_no === '1.1')
    return (
      <Plan11
          currentApas={apa_form}
          tableNo={'1.1'}
          title="A~Teaching Evaluation"
          childToParent={childToParent}
          state={menu}
      />
    );
  else if (form_no === '1.2')
    return (
      <Plan12
        currentApas={selectedApas}
        tableNo={'1.2'}
        dataConverter={{
          toTableData: convertToTableData,
          toRequestData: convertToRequestData
        }}
        state={menu}
      />
    );
  else if (form_no === '1.3')
    return (
      <Plan13 currentApas={selectedApas} tableNo={'1.3'} state={menu} />
    );
  else if (form_no === '2.1')
    return <Plan21 currentApas={selectedApas} tableNo={'2.1'} state={menu} />;
  if (form_no === '2.2')
    return <Plan22 currentApas={apa_form} tableNo={'2.2'} state={menu} />;
  else if (form_no === '2.3')
    return <Plan23 currentApas={selectedApas} tableNo={'2.3'} state={menu} />;
  else if (form_no === '2.4')
    return <Plan24 currentApas={selectedApas} tableNo={'2.4'} state={menu} />;
  else if (form_no === '2.5')
    return <Plan25 currentApas={selectedApas} tableNo={'2.5'} state={menu} />;
  else if (form_no === '3.1')
    return <Plan31 currentApas={selectedApas} tableNo={'3.1'} state={menu} />;
  else if (form_no === '3.2')
    return <Plan32 currentApas={selectedApas} tableNo={'3.2'} state={menu} />;
  else return <div>Table Not Found</div>;
};

export const Plans = ({ menu }) => {
  const [timer, setTimer] = useState(1000);

  return (
    <RemainingTimeContext.Provider value={{ timer, setTimer }}>
      <Plan menu={menu} />
    </RemainingTimeContext.Provider>
  );
};
